import 'bootstrap/js/dist/collapse.js';

(function($) {

}(jQuery));
